import { IconArrowRight, IconCalendar, IconMapPin, IconSearch, IconUsers } from "@tabler/icons-react";
import classes from "./SingleSearchForm.module.css";
import { useDispatch } from "react-redux";
import SearchFormText from "src/components/features/search-form/SearchForm/elements/SearchFormText/SearchFormText";
import SearchFormDate from "src/components/features/search-form/SearchForm/elements/SearchFormDate/SearchFormDate";
import { TRIP_TYPE, CABIN_CLASS_MAP } from "src/constants";
import { searchDataActions } from "src/store/search";
import { calculateTotalPassengers, getDisplayLocationValueMobile } from "src/utils/utils";
import { Fragment, useContext } from "react";
import Button from "src/components/UI/Button/Button";
import { SearchFormTextReadOnlyInputMobile } from "./SearchFormTextReadOnlyInputMobile";
import { ModalElementContext } from "src/context/modal-element-context";
import { useLocaleContext } from "src/context/locale-context";
import { useNavigation } from "react-router";
import DotPulseLoader from "src/components/UI/DotPulseLoader/DotPulseLoader";
import { getPluralizedCaseCode } from "src/utils/trip-utils";

export function MobileSingleSearchForm({
  onSearchFormClick,
  onStartSearch,
  isButtonEnabled,
  isResultsPage,
  searchData,
  dispatchSFState,
  hideCheckboxes,
  searchType,
}) {
  const dispatch = useDispatch();
  const navigationState = useNavigation().state;
  const { currentLanguage, getStringRes } = useLocaleContext();
  const { onClose } = useContext(ModalElementContext);
  const lang = currentLanguage.toUpperCase();

  const isRoundTrip = searchData.tripType === TRIP_TYPE.roundtrip;
  const trip = searchData.trips[0];

  const srcLocationValue = getDisplayLocationValueMobile(trip.srcLocation, lang);
  const destLocationValue = getDisplayLocationValueMobile(trip.destLocation, lang);
  const passengerNum = calculateTotalPassengers(searchData.passengers);

  const cabinClass = searchData.cabinClass
    ? getStringRes(CABIN_CLASS_MAP[searchData.cabinClass]).toLowerCase()
    : getStringRes("sf.field.cabin_class_any");

  const roomKey = getStringRes("sf.field.room");
  const roomLabel = roomKey === "sf.field.room" ? "istaba" : roomKey;

  const passengerValue =
    `${passengerNum} ` +
    getStringRes(`sf.field.passenger_${getPluralizedCaseCode(passengerNum)}`) +
    (searchType === "hotels" ? `, 1 ${roomLabel}` : "") +
    `, ${cabinClass}`;

  const onSwitchDirectionHandler = () => {
    if (isResultsPage) {
      const switchedLocations = {
        srcLocation: trip.destLocation,
        destLocation: trip.srcLocation,
      };
      dispatchSFState({ type: "UPDATE_TRIP", payload: switchedLocations, id: trip.id });
      dispatch(
        searchDataActions.updateUserInputTrip({
          tripId: trip.id,
          input: {
            srcLocation: switchedLocations.srcLocation.city,
            srcIata: switchedLocations.srcLocation.iata,
            destLocation: switchedLocations.destLocation.city,
            destIata: switchedLocations.destLocation.iata,
          },
        }),
      );
    } else {
      console.log("rerender on onSwitchDirectionHandler SingleSearchForm DISPATCH");
      dispatch(searchDataActions.switchDestWithSrcLocation({ id: trip.id, lang }));
    }
  };

  const onClearEndDateHandler = () => {
    if (isResultsPage) {
      dispatchSFState({ type: "UPDATE_TRIP", payload: { endDate: "" }, id: trip.id });
    } else {
      const payload = { tripId: trip.id, date: "" };
      dispatch(searchDataActions.updateEndDate(payload));
    }
  };

  const inputProps = {
    tripId: trip.id,
    onSwitchDirection: onSwitchDirectionHandler,
    values: { src: srcLocationValue, dest: destLocationValue },
    icon: isResultsPage ? undefined : IconMapPin,
  };

  return (
    <Fragment>
      <form
        name="main-search-form"
        className={`${classes.search} ${isRoundTrip ? classes.roundtrip : classes.oneway}`}>
        <SearchFormTextReadOnlyInputMobile {...inputProps} onClick={onSearchFormClick} />
        <SearchFormDate
          id="start-date"
          className={classes.startDate}
          value={trip.startDate}
          icon={isResultsPage ? undefined : IconCalendar}
          label={getStringRes("sf.field.date.depart")}
          onClick={() => onSearchFormClick("start-date", trip.id)}
        />
        {isRoundTrip && (
          <SearchFormDate
            id="end-date"
            className={classes.endDate}
            value={trip.endDate}
            icon={isResultsPage ? undefined : IconCalendar}
            label={getStringRes("sf.field.date.return")}
            onClick={() => onSearchFormClick("end-date", trip.id)}
            onClear={onClearEndDateHandler}
          />
        )}
        <SearchFormText
          id="passengers"
          className={classes.passengers}
          value={passengerValue}
          icon={isResultsPage ? undefined : IconUsers}
          label={getStringRes("sf.field.passengers")}
          onClick={() => onSearchFormClick("passengers")}
        />
        {isResultsPage && (
          <button
            className={classes.back}
            type="button"
            onClick={() => {
              dispatch(searchDataActions.fillUserInputPassengerOptions());
              dispatch(searchDataActions.fillUserInputTrips(lang));
              onClose();
            }}>
            {getStringRes("sf.mobile.button.back")}
          </button>
        )}
        <Button
          name={
            !isResultsPage && navigationState === "loading" ? (
              <DotPulseLoader opacity={0.2} color="#000" />
            ) : !isResultsPage ? (
              <>
                <IconSearch size={18} stroke={2} /> {getStringRes("sf.button.search")}
                <IconArrowRight size={18} stroke={2} />
              </>
            ) : (
              getStringRes("sf.button.search")
            )
          }
          data-testid="search-button"
          fontclass={classes.fontclass}
          onClick={onStartSearch}
          opts={{
            minHeight: "3rem",
            gridRow: hideCheckboxes ? "5" : undefined,
            marginTop: hideCheckboxes ? "1.5rem" : undefined,
          }}
          {...(!isResultsPage || isButtonEnabled ? { primary: true } : { secondary: true })}
          wide={!isResultsPage}
          shadow={!isResultsPage}
          disabled={!isButtonEnabled || navigationState === "loading"}
        />
      </form>
    </Fragment>
  );
}
